<div class="h-screen h-dvh flex overflow-hidden bg-slate-50 text-slate-900 font-sans">

  <!-- Desktop Sidebar -->
  <aside [class.w-64]="!isCollapsed" [class.w-20]="isCollapsed"
    class="hidden md:flex flex-col fixed inset-y-0 left-0 z-30 bg-white border-r border-slate-200 transition-[width] duration-200 ease-in-out shadow-sm overflow-x-hidden">

    <!-- Sidebar Header (Business & Branch Context Section) -->
    <div class="h-[70px] flex items-center px-4 border-b border-slate-200 select-none overflow-hidden"
      [class.justify-center]="isCollapsed" [class.justify-start]="!isCollapsed">
      <div class="flex items-center gap-3 min-w-0">
        <!-- Business Avatar / Isotype / Logo -->
        <div class="w-10 h-10 rounded-xl bg-gradient-to-tr from-primary-500/10 to-primary-500/20 text-primary-600 font-extrabold text-base flex items-center justify-center border border-primary-500/20 shrink-0 shadow-xs select-none overflow-hidden">
          <!-- Logo del negocio; sin logo o si no carga, el isotipo de FAISEN (nunca un src vacío). -->
          <img src="faisen-icon.png" [src]="brandLogo() ?? 'faisen-icon.png'" (error)="onBrandLogoError(brandLogo())" [alt]="brandLogo() ? activeContext.activeBusiness()?.businessName : 'FAISEN'" class="w-full h-full object-contain p-1 bg-white" />
        </div>
        <!-- Business & Establishment Names (Visible when expanded) -->
        <div *ngIf="!isCollapsed" class="flex flex-col min-w-0 overflow-hidden">
          <span class="text-sm font-bold text-slate-900 leading-tight truncate" [title]="activeContext.activeBusiness()?.businessName">
            {{ activeContext.activeBusiness()?.businessName || 'Mi Negocio' }}
          </span>
          <span class="text-xs text-slate-500 font-medium leading-none mt-1 truncate" [title]="activeContext.activeEstablishment()?.name">
            {{ activeContext.activeEstablishment()?.name || 'Sucursal' }}
          </span>
        </div>
      </div>
    </div>

    <!-- Navigation Menu Items -->
    <nav class="flex-1 py-3 px-3 overflow-y-auto overflow-x-hidden scrollbar-thin select-none space-y-1">
      <div *ngFor="let item of filteredMenuItems()" class="relative group"
        (mouseenter)="onMouseEnterItem(item, $event)" (mouseleave)="onMouseLeaveItem()">

        <!-- Rótulo de zona: esta sucursal / todo el negocio -->
        <p *ngIf="item.sectionStart && !isCollapsed"
          class="px-2.5 pt-3 pb-1 text-2xs font-bold uppercase tracking-wide select-none"
          [class.text-primary-600]="item.scope === 'branch'" [class.text-slate-500]="item.scope === 'business'">
          {{ item.sectionStart }}
        </p>
        <div *ngIf="item.sectionStart && isCollapsed && item.scope === 'business'" class="my-2 mx-2 border-t border-slate-200"></div>

        <!-- Standard Menu Link (No Children) -->
        <a *ngIf="!item.children" [routerLink]="item.route"
          routerLinkActive="!bg-primary-500 !text-white hover:!bg-primary-600 hover:!text-white shadow-md shadow-primary-500/20 font-bold"
          class="flex items-center gap-2.5 py-2 px-2.5 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-50 transition-colors duration-150 cursor-pointer select-none">
          <div class="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
            [class.bg-slate-100]="!isMenuOrChildActive(item)">
            <i [class]="item.icon + ' text-xs'"></i>
          </div>
          <span class="text-xs font-bold truncate"
            [class.opacity-0]="isCollapsed" [class.pointer-events-none]="isCollapsed">
            {{ item.label }}
          </span>
        </a>

        <!-- Parent Menu Item with Submenu (Has Children) -->
        <div *ngIf="item.children" (click)="toggleSubmenu(item.id, $event)"
          [class.bg-primary-50]="isMenuOrChildActive(item) || (isSubmenuExpanded(item.id) && !isCollapsed)"
          [class.text-primary-700]="isMenuOrChildActive(item) || (isSubmenuExpanded(item.id) && !isCollapsed)"
          [class.font-bold]="isMenuOrChildActive(item)"
          class="flex items-center justify-between py-2 px-2.5 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-50 transition-colors duration-150 cursor-pointer w-full select-none">
          <div class="flex items-center gap-2.5 min-w-0">
            <div class="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
              [class.bg-primary-100]="isMenuOrChildActive(item)"
              [class.text-primary-600]="isMenuOrChildActive(item)"
              [class.bg-slate-100]="!isMenuOrChildActive(item)"
              [class.text-slate-500]="!isMenuOrChildActive(item)">
              <i [class]="item.icon + ' text-xs'"></i>
            </div>
            <span class="text-xs font-bold truncate"
              [class.opacity-0]="isCollapsed" [class.pointer-events-none]="isCollapsed">
              {{ item.label }}
            </span>
          </div>
          <!-- Arrow Icon for Submenus -->
          <i *ngIf="!isCollapsed" class="pi pi-chevron-right text-2xs text-slate-400 transition-transform duration-200 shrink-0 ml-1.5"
            [class.rotate-90]="isSubmenuExpanded(item.id)"
            [class.text-primary-600]="isMenuOrChildActive(item)"></i>
        </div>

        <!-- Submenu Children -->
        <div *ngIf="item.children && isSubmenuExpanded(item.id) && !isCollapsed"
          class="ml-4 pl-2.5 border-l-2 border-slate-100 space-y-0.5 mt-1">
          <a *ngFor="let child of item.children" [routerLink]="child.route" [queryParams]="child.queryParams"
            routerLinkActive="!bg-primary-50 !text-primary-600 !font-bold"
            [routerLinkActiveOptions]="{ paths: 'exact', queryParams: child.queryParams ? 'exact' : 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
            class="flex items-center py-1.5 px-2.5 rounded-lg text-slate-500 hover:text-slate-900 hover:bg-slate-50 text-xs font-semibold transition-colors duration-150">
            <span class="truncate">{{ child.label }}</span>
          </a>
        </div>

      </div>
    </nav>

    <!-- Sidebar Footer (FAISEN Platform Branding) -->
    <div class="h-[70px] flex items-center justify-center px-4 border-t border-slate-200 bg-white select-none">
      <!-- Expanded State: Logo Horizontal Completo Centrado -->
      <div *ngIf="!isCollapsed" class="flex items-center justify-center w-full">
        <img src="images/logo-faisen/logo-faisen.png" alt="FAISEN" class="h-9 max-w-[85%] w-auto object-contain mx-auto" />
      </div>
      <!-- Collapsed State: Logo Isotipo Centrado -->
      <div *ngIf="isCollapsed" class="flex justify-center items-center w-full" title="Plataforma FAISEN">
        <img src="faisen-icon.png" alt="FAISEN" class="w-8 h-8 object-contain mx-auto" ngSkipImageOptimization />
      </div>
    </div>
  </aside>

  <!-- Fixed Hover Tooltip (Shown next to collapsed sidebar for items without children) -->
  <div *ngIf="isCollapsed && hoveredItemForTooltip" [ngClass]="{
      'bg-primary-500 text-white border-primary-500 shadow-md shadow-primary-500/20': isMenuOrChildActive(hoveredItemForTooltip),
      'bg-slate-800 text-white border-slate-700 shadow-md': !isMenuOrChildActive(hoveredItemForTooltip)
    }"
    class="fixed left-20 z-50 text-xs font-semibold px-3 py-2 rounded-lg border pointer-events-none whitespace-nowrap"
    [style.top.px]="tooltipTop">
    {{ hoveredItemForTooltip.label }}
    <!-- Arrow -->
    <div [ngClass]="{
        'bg-primary-500 border-primary-500': isMenuOrChildActive(hoveredItemForTooltip),
        'bg-slate-800 border-slate-700': !isMenuOrChildActive(hoveredItemForTooltip)
      }"
      class="absolute left-[-4px] top-1/2 -translate-y-1/2 w-2 h-2 border-l border-b rotate-45">
    </div>
  </div>

  <!-- Floating Submenu Panel (Shown next to collapsed sidebar on hover/click of submenu parent items) -->
  <div *ngIf="isCollapsed && activeOverlayMenu" (mouseenter)="onOverlayMouseEnter()"
    (mouseleave)="onOverlayMouseLeave()"
    class="fixed left-20 z-50 bg-white border border-slate-200 rounded-2xl shadow-xl py-3 w-56 animate-fade-in-left"
    [style.top.px]="overlayTop">
    <div class="px-4 pb-2 border-b border-slate-200 mb-2">
      <span class="text-xs uppercase font-bold text-primary-500 tracking-wider">{{
        activeOverlayMenu.label }}</span>
    </div>
    <div class="px-2 space-y-1">
      <a *ngFor="let child of activeOverlayMenu.children" [routerLink]="child.route" [queryParams]="child.queryParams" (click)="activeOverlayMenu = null"
        routerLinkActive="bg-primary-50 !text-primary-500 font-bold"
        [routerLinkActiveOptions]="{ paths: 'exact', queryParams: child.queryParams ? 'exact' : 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
        class="flex items-center py-1.5 px-2.5 rounded-lg text-slate-600 hover:text-slate-900 hover:bg-slate-100 text-xs font-semibold transition-colors duration-150">
        <span class="truncate">{{ child.label }}</span>
      </a>
    </div>
    <div class="absolute left-[-6px] top-5 w-3 h-3 bg-white border-l border-b border-slate-200 rotate-45">
    </div>
  </div>

  <!-- Mobile Sidebar / Drawer (Overlay on screen size < md) -->
  <div *ngIf="showMobileMenu" (click)="toggleMobileMenu()"
    class="md:hidden fixed inset-0 z-40 bg-slate-900/40 backdrop-blur-xs animate-fade-in">
  </div>
  <aside [class.translate-x-0]="showMobileMenu" [class.-translate-x-full]="!showMobileMenu"
    class="md:hidden fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-slate-200 transition-transform duration-200 flex flex-col shadow-2xl">

    <!-- Mobile Sidebar Header -->
    <div class="h-[70px] flex items-center px-4 border-b border-slate-200 justify-between">
      <div class="flex items-center gap-3 min-w-0 overflow-hidden">
        <div class="w-10 h-10 rounded-xl bg-gradient-to-tr from-primary-500/10 to-primary-500/20 text-primary-600 font-extrabold text-base flex items-center justify-center border border-primary-500/20 shrink-0 shadow-xs overflow-hidden">
          <img src="faisen-icon.png" [src]="brandLogo() ?? 'faisen-icon.png'" (error)="onBrandLogoError(brandLogo())" [alt]="brandLogo() ? activeContext.activeBusiness()?.businessName : 'FAISEN'" class="w-full h-full object-contain p-1 bg-white" />
        </div>
        <div class="flex flex-col min-w-0">
          <span class="text-sm font-bold text-slate-900 leading-tight truncate">
            {{ activeContext.activeBusiness()?.businessName || 'Mi Negocio' }}
          </span>
          <span class="text-xs text-slate-500 font-medium leading-none mt-1 truncate">
            {{ activeContext.activeEstablishment()?.name || 'Sucursal' }}
          </span>
        </div>
      </div>
      <button (click)="toggleMobileMenu()"
        class="text-slate-500 hover:text-slate-900 p-2 rounded-lg hover:bg-slate-100 transition-colors shrink-0 ml-2 cursor-pointer">
        <i class="pi pi-times text-lg"></i>
      </button>
    </div>

    <!-- Mobile Navigation Items -->
    <nav class="flex-1 py-3 px-3 overflow-y-auto space-y-1">
      <div *ngFor="let item of filteredMenuItems()" class="my-0.5">
        <p *ngIf="item.sectionStart"
          class="px-2.5 pt-3 pb-1 text-2xs font-bold uppercase tracking-wide select-none"
          [class.text-primary-600]="item.scope === 'branch'" [class.text-slate-500]="item.scope === 'business'">
          {{ item.sectionStart }}
        </p>
        <!-- Direct route item -->
        <a *ngIf="!item.children" [routerLink]="item.route"
          (click)="showMobileMenu = false"
          routerLinkActive="!bg-primary-500 !text-white hover:!bg-primary-600 hover:!text-white shadow-md shadow-primary-500/20 font-bold"
          class="flex items-center gap-2.5 py-2 px-2.5 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors duration-150">
          <div class="w-7 h-7 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">
            <i [class]="item.icon + ' text-xs'"></i>
          </div>
          <span class="font-bold text-xs">{{ item.label }}</span>
        </a>

        <!-- Submenu trigger -->
        <div *ngIf="item.children">
          <div (click)="toggleSubmenu(item.id, $event)"
            [class.bg-primary-50]="isMenuOrChildActive(item) || isSubmenuExpanded(item.id)"
            [class.text-primary-700]="isMenuOrChildActive(item) || isSubmenuExpanded(item.id)"
            [class.font-bold]="isMenuOrChildActive(item)"
            class="flex items-center justify-between py-2 px-2.5 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors duration-150 cursor-pointer">
            <div class="flex items-center gap-2.5 min-w-0">
              <div class="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
                [class.bg-primary-100]="isMenuOrChildActive(item)"
                [class.text-primary-600]="isMenuOrChildActive(item)"
                [class.bg-slate-100]="!isMenuOrChildActive(item)"
                [class.text-slate-500]="!isMenuOrChildActive(item)">
                <i [class]="item.icon + ' text-xs'"></i>
              </div>
              <span class="font-bold text-xs truncate">{{ item.label }}</span>
            </div>
            <i class="pi pi-chevron-right text-2xs text-slate-400 transition-transform"
              [class.rotate-90]="isSubmenuExpanded(item.id)"
              [class.text-primary-600]="isMenuOrChildActive(item)"></i>
          </div>

          <div *ngIf="isSubmenuExpanded(item.id)" class="ml-4 pl-2.5 border-l-2 border-slate-100 space-y-0.5 mt-1">
            <a *ngFor="let child of item.children" [routerLink]="child.route" [queryParams]="child.queryParams"
              (click)="showMobileMenu = false"
              routerLinkActive="!bg-primary-50 !text-primary-600 !font-bold"
              [routerLinkActiveOptions]="{ paths: 'exact', queryParams: child.queryParams ? 'exact' : 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
              class="flex items-center py-1.5 px-2.5 rounded-lg text-slate-500 hover:text-slate-900 hover:bg-slate-50 text-xs font-semibold transition-colors">
              <span class="truncate">{{ child.label }}</span>
            </a>
          </div>
        </div>
      </div>
    </nav>

    <!-- Mobile Sidebar Footer -->
    <div class="h-[70px] flex items-center justify-center px-6 border-t border-slate-200 bg-white">
      <img src="images/logo-faisen/logo-faisen.png" alt="FAISEN" class="h-9 max-w-[85%] w-auto object-contain mx-auto" />
    </div>
  </aside>

  <!-- Layout Wrapper -->
  <div [class.md:pl-64]="!isCollapsed" [class.md:pl-20]="isCollapsed"
    class="flex-1 flex flex-col transition-[padding] duration-200 ease-in-out h-full overflow-hidden min-w-0">

    <!-- Header Section -->
    <header
      class="shrink-0 h-[70px] bg-white border-b border-slate-200 flex items-center justify-between px-6 z-20">

      <!-- Left side: Hamburger and Section title -->
      <div class="flex items-center gap-4">
        <!-- Desktop toggle -->
        <button (click)="toggleSidebar()"
          class="hidden md:flex w-10 h-10 rounded-xl items-center justify-center text-slate-500 hover:bg-slate-100 hover:text-primary-500 transition-colors">
          <i class="pi pi-bars text-lg"></i>
        </button>
        <!-- Mobile toggle -->
        <button (click)="toggleMobileMenu()"
          class="md:hidden w-10 h-10 rounded-xl flex items-center justify-center text-slate-500 hover:bg-slate-100 hover:text-primary-500 transition-colors">
          <i class="pi pi-bars text-lg"></i>
        </button>
        <!-- Espacio libre a propósito: la pantalla ya se llama en su propio título y el menú lateral navega. Aquí irán después las acciones globales (notificaciones, etc.). -->
      </div>

      <!-- Right side: Notifications, Profile -->
      <div class="flex items-center gap-4">

        <!-- Zona horaria de la sucursal activa (md en adelante; en pantallas chicas va dentro del menú de usuario) -->
        <div class="hidden md:flex items-center gap-2.5 px-3 py-1.5 rounded-xl border border-slate-200 bg-white select-none"
          [attr.title]="'Zona horaria de la sucursal: ' + zoneClock().tz">
          <i class="pi pi-clock text-slate-500 text-sm"></i>
          <div class="flex flex-col leading-tight">
            <span class="text-sm font-bold text-slate-900 tabular-nums">{{ zoneClock().time }}</span>
            <span class="text-2xs text-slate-500 hidden xl:inline">{{ zoneClock().tz }} · {{ zoneClock().offset }}</span>
            <span class="text-2xs text-slate-500 xl:hidden">{{ zoneClock().offset }}</span>
          </div>
        </div>

        <!-- Menú de usuario: se cierra al hacer clic fuera o con Esc -->
        <div class="relative" data-profile-menu>
          <button type="button" (click)="toggleProfileMenu()"
            aria-haspopup="menu" [attr.aria-expanded]="showProfileMenu" aria-label="Menú de usuario"
            class="relative z-50 flex items-center gap-3 text-left cursor-pointer p-1 rounded-2xl hover:bg-slate-100/80 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40">
            <div class="relative shrink-0 select-none">
              <div
                class="w-10 h-10 rounded-2xl bg-gradient-to-tr from-primary-700 to-primary-500 flex items-center justify-center text-white font-bold text-sm shadow-xs ring-2 ring-white">
                <span class="leading-none text-center">{{ currentUser.initials }}</span>
              </div>
              <span class="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-success-500 ring-2 ring-white" aria-hidden="true"></span>
            </div>
            <div class="hidden sm:flex flex-col select-none pr-1">
              <span class="text-sm font-bold text-slate-900 leading-tight">{{ currentUser.name }}</span>
              <span class="text-xs text-slate-500 font-normal leading-none mt-1 truncate max-w-[180px]">
                {{ currentUser.email }}
              </span>
            </div>
            <i class="pi pi-chevron-down text-slate-500 text-xs hidden sm:block transition-transform duration-200"
              [class.rotate-180]="showProfileMenu" aria-hidden="true"></i>
          </button>

          @if (showProfileMenu) {
          <!-- Capa transparente: cualquier clic fuera del menú lo cierra -->
          <div class="fixed inset-0 z-40" (click)="closeProfileMenu()" aria-hidden="true"></div>
          <div role="menu" aria-label="Menú de usuario"
            class="absolute right-0 mt-3 w-72 max-w-[calc(100vw-2rem)] bg-white border border-slate-200 rounded-2xl shadow-2xl p-2 z-50 animate-fade-in">

            <!-- Resumen del usuario -->
            <div class="px-3 py-2.5 bg-slate-50 rounded-xl mb-2 border border-slate-200 select-none">
              <p class="text-sm font-bold text-slate-900 leading-tight truncate" [title]="currentUser.name">{{ currentUser.name }}</p>
              <p class="text-xs text-slate-500 truncate mt-0.5" [title]="currentUser.email">{{ currentUser.email }}</p>
              <span class="inline-flex items-center mt-2 px-2 py-0.5 rounded-md text-2xs font-bold bg-primary-50 text-primary-700 border border-primary-200 uppercase tracking-wide">
                {{ currentUser.role }}
              </span>
            </div>

            <!-- Zona horaria (solo pantallas chicas: en las grandes está en el encabezado) -->
            <div class="md:hidden flex items-center gap-3 p-2 mb-1 rounded-xl bg-slate-50 border border-slate-200 select-none">
              <i class="pi pi-clock text-slate-500 text-sm" aria-hidden="true"></i>
              <div class="flex flex-col leading-tight min-w-0">
                <span class="text-xs font-bold text-slate-900 tabular-nums">{{ zoneClock().time }}</span>
                <span class="text-2xs text-slate-500 truncate">{{ zoneClock().tz }} · {{ zoneClock().offset }}</span>
              </div>
            </div>

            @if (activeContext.canChangeBranch() || activeContext.canChangeBusiness()) {
            <div class="mb-1">
              <p class="px-2 pt-1 pb-1 text-2xs font-bold uppercase tracking-wide text-slate-500">Espacio de trabajo</p>
              <div class="space-y-0.5">
                @if (activeContext.canChangeBranch()) {
                <button type="button" role="menuitem" (click)="changeBranch()"
                  class="w-full flex items-center gap-3 p-2 rounded-xl text-left hover:bg-slate-50 focus-visible:bg-slate-50 outline-none transition-colors cursor-pointer group">
                  <span class="w-8 h-8 rounded-lg bg-slate-100 group-hover:bg-primary-50 text-slate-500 group-hover:text-primary-600 flex items-center justify-center shrink-0 transition-colors">
                    <i class="pi pi-shop text-xs" aria-hidden="true"></i>
                  </span>
                  <span class="flex flex-col min-w-0">
                    <span class="text-xs font-semibold text-slate-800 group-hover:text-primary-600 transition-colors">Cambiar de Sucursal</span>
                    <span class="text-2xs text-slate-500 truncate mt-0.5">Actual: {{ activeContext.activeEstablishment()?.name }}</span>
                  </span>
                  <i class="pi pi-chevron-right text-2xs text-slate-400 group-hover:text-primary-500 transition-colors ml-auto shrink-0" aria-hidden="true"></i>
                </button>
                }
                @if (activeContext.canChangeBusiness()) {
                <button type="button" role="menuitem" (click)="changeBusiness()"
                  class="w-full flex items-center gap-3 p-2 rounded-xl text-left hover:bg-slate-50 focus-visible:bg-slate-50 outline-none transition-colors cursor-pointer group">
                  <span class="w-8 h-8 rounded-lg bg-slate-100 group-hover:bg-primary-50 text-slate-500 group-hover:text-primary-600 flex items-center justify-center shrink-0 transition-colors">
                    <i class="pi pi-building text-xs" aria-hidden="true"></i>
                  </span>
                  <span class="flex flex-col min-w-0">
                    <span class="text-xs font-semibold text-slate-800 group-hover:text-primary-600 transition-colors">Cambiar de Negocio</span>
                    <span class="text-2xs text-slate-500 truncate mt-0.5">Actual: {{ activeContext.activeBusiness()?.businessName }}</span>
                  </span>
                  <i class="pi pi-chevron-right text-2xs text-slate-400 group-hover:text-primary-500 transition-colors ml-auto shrink-0" aria-hidden="true"></i>
                </button>
                }
              </div>
              <div class="h-px bg-slate-100 my-1.5 mx-2"></div>
            </div>
            }

            <div class="mb-1">
              <p class="px-2 pt-1 pb-1 text-2xs font-bold uppercase tracking-wide text-slate-500">Mi cuenta</p>
              <a routerLink="/admin/profile" role="menuitem" (click)="closeProfileMenu()"
                class="w-full flex items-center gap-3 p-2 rounded-xl text-left hover:bg-slate-50 focus-visible:bg-slate-50 outline-none transition-colors cursor-pointer group">
                <span class="w-8 h-8 rounded-lg bg-slate-100 group-hover:bg-primary-50 text-slate-500 group-hover:text-primary-600 flex items-center justify-center shrink-0 transition-colors">
                  <i class="pi pi-user text-xs" aria-hidden="true"></i>
                </span>
                <span class="flex flex-col min-w-0">
                  <span class="text-xs font-semibold text-slate-800 group-hover:text-primary-600 transition-colors">Mi Perfil</span>
                  <span class="text-2xs text-slate-500 truncate mt-0.5">Seguridad y datos personales</span>
                </span>
                <i class="pi pi-chevron-right text-2xs text-slate-400 group-hover:text-primary-500 transition-colors ml-auto shrink-0" aria-hidden="true"></i>
              </a>
            </div>

            <div class="h-px bg-slate-100 my-1.5 mx-2"></div>

            <button type="button" role="menuitem" (click)="confirmLogout()"
              class="w-full flex items-center gap-3 p-2 rounded-xl text-left hover:bg-danger-50 focus-visible:bg-danger-50 outline-none transition-colors cursor-pointer group">
              <span class="w-8 h-8 rounded-lg bg-danger-50 text-danger-600 group-hover:bg-danger-100 flex items-center justify-center shrink-0 transition-colors">
                <i class="pi pi-sign-out text-xs" aria-hidden="true"></i>
              </span>
              <span class="flex flex-col">
                <span class="text-xs font-bold text-danger-600">Cerrar Sesión</span>
                <span class="text-2xs text-slate-500">Finalizar sesión activa</span>
              </span>
            </button>
          </div>
          }
        </div>

      </div>
    </header>

    <!-- Main Content Outlet Area -->
    <main class="flex-1 p-6 lg:p-8 overflow-y-auto min-h-0">
      @if (subNotice(); as notice) {
        @if (!onSubscriptionPage) {
          @if (notice.kind === 'PAST_DUE') {
            <div role="alert" class="mb-6 p-4 rounded-2xl border border-warning-200 bg-warning-50 flex flex-wrap items-center justify-between gap-3 shadow-xs">
              <div class="min-w-0">
                <p class="text-sm font-bold text-warning-900">Pago pendiente de tu suscripción</p>
                <p class="text-xs text-warning-700 mt-0.5 leading-relaxed">
                  Te quedan {{ notice.days }} {{ notice.days === 1 ? 'día' : 'días' }} de gracia. Después se suspenderá el acceso al negocio.
                </p>
              </div>
              <app-button type="primary" size="small" icon="pi pi-upload" label="Reportar pago" (onClick)="goToSubscription()"></app-button>
            </div>
          } @else if (notice.kind === 'SUSPENDED') {
            <div role="alert" class="mb-6 p-4 rounded-2xl border border-danger-200 bg-danger-50 flex flex-wrap items-center justify-between gap-3 shadow-xs">
              <div class="min-w-0">
                <p class="text-sm font-bold text-danger-900">Acceso suspendido por falta de pago</p>
                <p class="text-xs text-danger-700 mt-0.5 leading-relaxed">
                  Reporta tu transferencia en Mi suscripción para reactivar el servicio de inmediato.
                </p>
              </div>
              <app-button type="danger" size="small" icon="pi pi-upload" label="Reportar pago" (onClick)="goToSubscription()"></app-button>
            </div>
          } @else {
            <div role="alert" class="mb-6 p-4 rounded-2xl border border-danger-200 bg-danger-50 shadow-xs">
              <p class="text-sm font-bold text-danger-900">Suscripción cancelada</p>
              <p class="text-xs text-danger-700 mt-0.5 leading-relaxed">
                El acceso del negocio está deshabilitado. Comunícate con FAISEN para reactivarla.
              </p>
            </div>
          }
        }
      }
      <router-outlet></router-outlet>
    </main>

    <!-- Admin Footer -->
    <footer
      class="shrink-0 bg-white border-t border-slate-200 px-6 py-4 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 font-medium select-none">
      <span>© 2026 <a href="/" target="_blank" class="hover:text-primary-500 transition-colors font-bold">FAISEN</a>.
        Todos los derechos
        reservados.</span>
      <div class="flex gap-4 mt-2 sm:mt-0">
        <a class="hover:text-primary-500 cursor-pointer">Soporte</a>
        <span>·</span>
        <a class="hover:text-primary-500 cursor-pointer">Términos y Privacidad</a>
      </div>
    </footer>

    <!-- ─── Visor Global de Imágenes (disponible en toda la app) ─── -->
    <app-image-viewer></app-image-viewer>

  </div>

  <!-- Confirm Dialog: Cerrar Sesión -->
  <app-logout-confirm [(visible)]="showLogoutConfirm" (confirmed)="logout()"></app-logout-confirm>

  <!-- Dock de exportaciones: todas las descargas Excel y PDF se ven aquí -->
  <app-export-dock></app-export-dock>

</div>